import React from 'react';
import styles from './disk.module.scss';

const PartitionInfo = ({part}) => {
  const partitions = (part+"").trim().split('\n').map(line => {
    const [name, size] = line.split(' ');
    return { name, size };
  });
  
  return (
    <div className={styles.disk_info_container}>
      <span><h2>Partition Information</h2></span>
      {partitions.map((partition, index) => (
        <div key={index} className={styles.disk_info_box}>
          <div className={styles.disk_info_name}>{`/dev/${partition.name}`}</div>
          <div className={styles.disk_info_size}>{partition.size}</div>
        </div>
      ))}
    </div>
  );
};

export default PartitionInfo;